export default __webpack_public_path__ + "static/media/editCompany.b17c006c.png";